import React from "react"
import Table from "react-bootstrap/Table"

import styles from "./TableFeatures.module.scss"

const enhance = (item) => {
  return item
    .replaceAll(
      "✓",
      "<span class='table-features-checkmark'><span class='sr-only'>✓</span></span>"
    )
    .replaceAll("<em>€</em>", "<span class='table-features-euro'>€</span>")
}

const TableFeatures = ({ caption, head, body }) => {
  const headList = head?.map((item, i) => {
    return (
      <th scope="col" key={i}>
        {item}
      </th>
    )
  })

  const bodyList = body?.map((item, i) => {
    const row = item.row.map((item, i) => {
      return (
        <td key={i} dangerouslySetInnerHTML={{ __html: enhance(item) }}></td>
      )
    })

    return <tr key={i}>{row}</tr>
  })

  const table = (
    <Table responsive>
      {caption && <caption>{caption}</caption>}
      {headList && (
        <thead>
          <tr>{headList}</tr>
        </thead>
      )}
      {bodyList && <tbody>{bodyList}</tbody>}
    </Table>
  )

  return <section className={styles.table}>{table}</section>
}

export default TableFeatures
